import { render, staticRenderFns } from "./ScreenChartGantt.vue?vue&type=template&id=5622e01f&scoped=true"
import script from "./ScreenChartGantt.vue?vue&type=script&lang=js"
export * from "./ScreenChartGantt.vue?vue&type=script&lang=js"
import style0 from "./ScreenChartGantt.vue?vue&type=style&index=0&id=5622e01f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5622e01f",
  null
  
)

export default component.exports